import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType, PatchQueryArgsType } from "../../../types";
import {
  GetWorkStationDetailsResponseType,
  GetWorkStationsParams,
  GetWorkStationsResponseType,
} from "../../../types/org-setting/workStation";

export const workStationApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkStations: builder.query<
      GetWorkStationsResponseType,
      GetQueryArgsType<GetWorkStationsParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getWorkStations,
        ...queryArgs,
      }),
      providesTags: ["GetWorkStations"],
    }),
    getWorkStationDetails: builder.query<
      GetWorkStationDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getWorkStationDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [
        {
          type: "GetWorkStationDetails",
          id,
        },
      ],
    }),
    addWorkStation: builder.mutation({
      query: (data) => ({
        url: API_URL.addWorkStation,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetWorkStations"];
        return [];
      },
    }),
    updateWorkStation: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateWorkStation}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetWorkStations",
            {
              type: "GetWorkStationDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateWorkStationStatus: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateWorkStationStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetWorkStations",
            {
              type: "GetWorkStationDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetWorkStationsQuery,
  useGetWorkStationDetailsQuery,
  useAddWorkStationMutation,
  useUpdateWorkStationMutation,
  useUpdateWorkStationStatusMutation,
} = workStationApi;
